<template>
  <v-row no-gutters>
    <slot name="prependButtons" />
    <v-col v-for="button in filteredButtons" :key="button.name" cols="auto">
      <v-badge
        overlap
        bordered
        :content="getButtonAmount(button.amount)"
        :offset-y="15"
        :offset-x="15"
        :value="button.amount > 0"
        color="error"
      >
        <base-rounded-button
          @click="onClick(button.name, button)"
          color="rgba(235, 235, 235, 0.5)"
          size="x-small"
          v-bind="button"
          icon-color="#202124"
        />
      </v-badge>
    </v-col>
  </v-row>
</template>

<script>
import BaseRoundedButton from '@/components/BaseRoundedButton';
import { get } from 'vuex-pathify';

export default {
  name: 'FeatureCardZdmButtons',
  components: {
    BaseRoundedButton,
  },
  props: {
    additionalButtons: {
      type: Array,
      default: () => [],
    },
    permissions: {
      type: Number,
      required: true,
    },
    geometry: {
      type: Object,
      required: true,
    },
    featureId: {
      type: [Number, String],
      default: null,
    },
    layerId: {
      type: Number,
      default: null,
    },
    streetAttributeValue: {
      type: String,
      default: null,
    },
    districtAttributeValue: {
      type: String,
      default: null,
    },
    numberAttributeValue: {
      type: [String, Number],
      default: null,
    },
    hasAddFailureButton: {
      type: Boolean,
      default: true,
    },
    dataSource: {
      type: String,
      required: true,
    },
  },
  computed: {
    historyAmount: get('changeHistory/history@:dataSource@:featureId.length'),
    notesAmount: get('notes/notes@:dataSource@:featureId.length'),
    attachmentsAmount: get('attachments/attachments.length'),
    isDatasourceConnectedToExternalSystem: get('externalSystems/connectedDataSources@:dataSource'),
    isExternalSystemsEnabled: get('admin/settingsValues@external_systems_module_enabled'),
    relations: get('relations/relations'),
    relationsCount() {
      return this.relations?.[this.dataSource]?.[this.featureId]?.length || [];
    },
    baseButtons() {
      return [
        {
          name: 'zoomTo',
          icon: 'mdi-magnify',
          tooltip: this.$i18n.t('sidebar.zoomOnMap'),
        },
        {
          name: 'addFailure',
          icon: 'mdi-wrench',
          tooltip: this.$i18n.t('button.createFailure'),
          isVisible: this.hasAddFailureButton,
        },
        {
          name: 'external_systems',
          tooltip: this.$i18n.t('dialog.external_systems.tooltip'),
          innerText: 'ZSI',
          isVisible: this.isExternalSystemsEnabled && this.isDatasourceConnectedToExternalSystem ? true : false,
        },
      ];
    },
    mergedButtons() {
      return this.additionalButtons.reduce(
        (total, current) => {
          total.splice(current.index, 0, current);
          return total;
        },
        [...this.baseButtons]
      );
    },
    filteredButtons() {
      return this.mergedButtons.filter(button => button.isVisible === undefined || button.isVisible);
    },
  },
  methods: {
    onClick(name, button) {
      const dict = {
        zoomTo: this.zoomToFeature,
        addFailure: this.addFailure,
      };
      dict[name]?.();
      this.$emit(name, button);
    },
    zoomToFeature() {
      const { crs } = this.geometry;
      this.$root.$emit('createGeomAndFitView', { ...this.geometry, crs });
    },
    async addFailure() {
      await this.$router.push({ name: 'zdmFailureReport' });
      this.$root.$emit('setFailureLamp', {
        layer_id: this.layerId,
        id: this.featureId,
        number: this.numberAttributeValue,
        street: this.streetAttributeValue,
        district: this.districtAttributeValue,
      });
    },
    getButtonAmount(amount) {
      return amount ? amount.toString() : null;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-badge__badge {
  z-index: 2 !important;
}
</style>
